export default __webpack_public_path__ + "images/b06ba8f49d865ae7386b7afafa199b98.svg";